
import { useMutation, useQuery, useQueryClient } from 'react-query'
import minigridAPI from '../../service/minigridAPI'
import { AxiosError } from 'axios'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { minigridMapState } from '../../redux/minigrid.mapstate'
import { setIsLoadingListMinigridAction, setQuerySearchAction } from '../../redux/minigrid.actions'
import { FileDtoIn } from '../../../../common/types/files.types'

import { MinigirdPatch } from '../../types/minigridtypes'

export interface UseMinigridConfig{
    getCurrentPage?: () => number | null
    goToPage?: (page: number) => void
    setQuerySearch?: (querySearch: string | null) => void
    getQuerySearch?: () => string | null,
    getAccoundId?: () => string | null,
    getUserId?: () => string | null
}
export type CallbackFunction = (result:{result?: any, error?:any}) => void
/**
*
* useMinigridCore
* @function useMinigridCore
* Core logic for the useMinigrid hook
*   - 
* @param {UseMinigridConfig} config
* @returns {Object}
* 
 */
export const useMinigridCore = ({
    getCurrentPage,
    goToPage,
    getQuerySearch,
    setQuerySearch : setQuerySearchToParam,
    getAccoundId,
    getUserId
} : UseMinigridConfig) => {

    const queryClient = useQueryClient()


    const currentPage = getCurrentPage ? getCurrentPage() : null

    const {minigrid : minigridState} = useSelector(minigridMapState)
    const dispatch = useDispatch()

    const  accountId = getAccoundId ? getAccoundId() : null
    const userId = getUserId ? getUserId() : null
    const allMinigridQuery = useQuery({
        queryKey: ['minigrid', currentPage, minigridState.querySearch],
        queryFn: () => minigridAPI.getAllMinigrids(currentPage || 1,10, {querySearch: minigridState.querySearch, accountId: accountId}),
    })

    useEffect(() => {
        if(currentPage){
            setPage(Number(currentPage))
        }
    },[currentPage]) // eslint-disable-line
    const setPage = (page: number) => {

        goToPage && goToPage(page)
    }

    const setQuerySearch = (querySearch: string | null) => {
        setQuerySearchToParam && setQuerySearchToParam(querySearch)
        dispatch(setQuerySearchAction(querySearch))
    }

    const setMingridListIsLoading = (isLoading: boolean) => {
        dispatch(setIsLoadingListMinigridAction(isLoading))
    }



    const deleteMinigrid = useMutation({
        mutationFn: ({minigridId}:{minigridId: string, callbackFunc?:CallbackFunction}) => minigridAPI.deleteMinigrid(minigridId),
        onSettled: () => {
            allMinigridQuery.refetch()
        }
    })

    const uploadFileMinigrid = useMutation({
        mutationFn: ({minigridId, file}:{minigridId: string, file: FileDtoIn}) => minigridAPI.uploadImageToMinigrid(file, minigridId),
        onSettled: () => {
            allMinigridQuery.refetch()
        }
    })


    const createMinigrid = useMutation({
        mutationFn: ({minigrid, files, callbackFunc}:{minigrid: MinigirdPatch, files?: FileDtoIn[], callbackFunc?: CallbackFunction } ) => minigridAPI.createMinigrid({...minigrid, minigrid_account_id: accountId || "", minigrid_user_id: userId || "" }).then(
            (result) => {
                if (callbackFunc) {
                    queryClient.invalidateQueries('minigrid')
                    allMinigridQuery.refetch()

                    if(files){
                        files.forEach((file) => {
                            uploadFileMinigrid.mutate({minigridId: result.minigrid_id, file})
                        })
                    }
                    callbackFunc({result, error: undefined})
                }
            }
            
        ).catch(
            (error) => {
                if (callbackFunc) {
                    callbackFunc({result: undefined, error})
                }
                return Promise.reject(error)
            }
        ),
 
        onSettled: async () => {
     
            queryClient.invalidateQueries('minigrid')
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['minigrid'], refetchInactive: true })
        }

    })



    return {
        allMinigridQuery : {
            data : allMinigridQuery.data,
            isLoading : allMinigridQuery.isLoading || minigridState.isLoadingListMinigrid,
            isSuccess : allMinigridQuery.isSuccess,
            isError : allMinigridQuery.isError,
            error : allMinigridQuery.error as AxiosError,
            refetch : allMinigridQuery.refetch,
            isRefetching : allMinigridQuery.isRefetching,
            currentPage,
            setPage,
            setMingridListIsLoading,
            setQuerySearch,
            getQuerySearch

        },
        deleteMinigrid : {
            mutate : deleteMinigrid.mutate,
            isLoading : deleteMinigrid.isLoading,
            isSuccess : deleteMinigrid.isSuccess,
            isError : deleteMinigrid.isError,
            error : deleteMinigrid.error as AxiosError
        },
        createMinigrid : {
            mutate : createMinigrid.mutate,
            isLoading : createMinigrid.isLoading,
            isSuccess : createMinigrid.isSuccess,
            isError : createMinigrid.isError,
            error : createMinigrid.error as AxiosError
        },
     
        
    }
}

export default useMinigridCore
